import React, { useState } from "react";
import MasterTable from "../common/MasterTable";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import Loader from "../Loader/Loader";
import { format, parse } from "date-fns";
import ReportCourierFilterModal from "./ReportCourierFilterModal";
import ReportItemModal from "./ReportItemModal";

// Default filter structure
const defaultFilterData = {
  reportId: "",
  oemName: "",
  courierSend: [],
  fromDate: "",
  toDate: "",
};

// Dummy data (10 rows)
const dummyReportData = [
  {
    reportId: "REP001",
    oemName: "Blue Dart",
    deliveryDates: "2025-09-20 ",
    courierSend: "SEND",
    itemsIncluded: "5 Items",
  },
  {
    reportId: "REP002",
    oemName: "DTDC",
    deliveryDates: "2025-09-22 ",
    courierSend: "PENDING",
    itemsIncluded: "3 Items",
  },
  {
    reportId: "REP003",
    oemName: "Delhivery",
    deliveryDates: "2025-09-23 ",
    courierSend: "FAILED",
    itemsIncluded: "8 Items",
  },
  {
    reportId: "REP004",
    oemName: "Blue Dart",
    deliveryDates: "2025-09-22 ",
    courierSend: "SEND",
    itemsIncluded: "12 Items",
  },
  {
    reportId: "REP005",
    oemName: "DTDC",
    deliveryDates: "2025-09-23 ",
    courierSend: "PENDING",
    itemsIncluded: "6 Items",
  },
  {
    reportId: "REP006",
    oemName: "Delhivery",
    deliveryDates: "2025-09-22 ",
    courierSend: "SEND",
    itemsIncluded: "10 Items",
  },
  {
    reportId: "REP007",
    oemName: "Blue Dart",
    deliveryDates: "2025-09-21 ",
    courierSend: "FAILED",
    itemsIncluded: "7 Items",
  },
  {
    reportId: "REP008",
    oemName: "DTDC",
    deliveryDates: "2025-09-22 ",
    courierSend: "SEND",
    itemsIncluded: "9 Items",
  },
  {
    reportId: "REP009",
    oemName: "Delhivery",
    deliveryDates: "2025-09-22 ",
    courierSend: "PENDING",
    itemsIncluded: "15 Items",
  },
  {
    reportId: "REP010",
    oemName: "Blue Dart",
    deliveryDates: "2025-09-22 ",
    courierSend: "SEND",
    itemsIncluded: "20 Items",
  },
];

// Table headers
const reportHeader = [
  "Sr No",
  "OEM Name",
  "Delivery Date",
  "Courier Status",
  "Items Included",
];

// Map headers to object keys
const reportHeaderToKeyMap = {
  "Sr No": "srNo",
  "OEM Name": "oemName",
  "Delivery Date": "deliveryDate",
  "Courier Status": "courierSend",
  "Items Included": "itemsIncluded",
};

const modifyStructure = (response, handleItemsIncludedClick) => {
  // Group by OEM
  const grouped = response.reduce((acc, r) => {
    (acc[r.oemName] ||= []).push(r);
    return acc;
  }, {});

  let srCounter = 1; // Sr No per OEM group

  return Object.entries(grouped).flatMap(([oemName, reports]) => {
    // Build rows for this OEM
    const rows = reports.map((report) => {
      const parsed = parse(
        report.deliveryDates.trim(),
        "yyyy-MM-dd",
        new Date()
      );
      const formattedDate = format(parsed, "dd-MM-yyyy");

      return {
        srNo: srCounter, // temp: same for all rows in group
        oemName, // temp: same for all rows in group
        deliveryDate: formattedDate,
        courierSend: report.courierSend,
        itemsIncluded: (
          <span
            className="text-blue-600 underline cursor-pointer"
            onClick={() => handleItemsIncludedClick(report)}
          >
            {report.itemsIncluded}
          </span>
        ),
      };
    });

    // Put BOTH Sr No and OEM on the middle row of the group
    const midIndex = Math.floor(rows.length / 2);

    const result = rows.map((row, idx) => ({
      ...row,
      srNo:
        idx === midIndex ? (
          <div style={{ width: "40px", textAlign: "left" }}>{row.srNo}</div>
        ) : (
          <></>
        ),
      oemName:
        idx === midIndex ? (
          <span className="block text-left pl-4">{row.oemName}</span>
        ) : (
          <></>
        ),
    }));

    srCounter++; // next OEM group
    return result;
  });
};

const ReportCourier = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageDetails, setPageDetails] = useState({
    pageNo: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecords: dummyReportData.length,
  });

  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);

  const [isReportItemModalOpen, setIsReportItemModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const openModalFilter = () => setIsModalOpenFilter(true);
  const closeModalFilter = () => setIsModalOpenFilter(false);

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const handleItemsIncludedClick = (row) => {
    setSelectedReport(row);
    setIsReportItemModalOpen(true);
  };

  return (
    <>
      <HeaderWithBreadcrumb title="Report Courier" breadcrumb="Reports" />
      <div>
        <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
          {loading ? (
            <Loader />
          ) : (
            <MasterTable
              loading={loading}
              headers={reportHeader}
              data={modifyStructure(dummyReportData, handleItemsIncludedClick)}
              entityType="ReportCourier"
              headerToKeyMap={reportHeaderToKeyMap}
              noData={dummyReportData.length === 0}
              pageDetails={pageDetails}
              currentPage={currentPage}
              pageSize={pageSize}
              totalRecord={dummyReportData.length}
              setCurrentPage={setCurrentPage}
              setPageSize={setPageSize}
              hideAction="hideAction"
              filterData={filterData}
              handleReset={handleReset}
              openModalFilter={openModalFilter}
            />
          )}

          {/* Filter Modal */}
          {isModalOpenFilter && (
            <ReportCourierFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
              defaultFilterData={defaultFilterData}
            />
          )}

          {isReportItemModalOpen && (
            <ReportItemModal
              show={isReportItemModalOpen}
              handleClose={() => setIsReportItemModalOpen(false)}
              reportData={selectedReport}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ReportCourier;
